import { LoadingDot } from "../../components/loading-dot";

export class UserPrivateViewGenericItems {
  static instance;

  constructor() {
    if (UserPrivateViewGenericItems.instance) {
      throw new Error('Solo puede haber una instancia de UserPrivateViewGenericItems');
    }

    this.items = [];
    this.mode = 'list';
    if (window.innerWidth < 600) {
      this.mode = 'thumbs';
    }
  }

  static getInstante() {
    if (!UserPrivateViewGenericItems.instance) {
      UserPrivateViewGenericItems.instance = new UserPrivateViewGenericItems();
    }
    return UserPrivateViewGenericItems.instance;
  }

  async loadMain(_controller, _title, _entity) {
    let header = this.renderHeader(_title, _entity);
    document.getElementById('user-content').innerHTML = header + '<div id="items" class="mt20">' + LoadingDot.render() + '</div>';

    let publish = await _controller.model.read();
    let hidden = await _controller.model.readHide();

    let items = [...publish.data, ...hidden.data];
    items.sort((a, b) => b.dateCreate - a.dateCreate);

    _controller.loading.hide();

    if (localStorage.getItem('entity-user-mode-' + _entity) == 'thumbs' || window.innerWidth < 600) {
      this.thumbs(items, _entity);
    } else {
      this.list(items, _entity);
    }
  }

  renderHeader(_title, _entity) {
    return `
    <div class="service-header-content box">
      <h1 style="text-align: left;">${_title}</h1>
      <div class="header-group">
        <div class="search-input-group" style="width: 100%;">
          <input type="text" id="service-search-input" class="search-input"
            placeholder="Filtrar por título, descripción, fecha, precio o estado ..."
            onkeyup="app.userPrivateController.viewGenericItems.filterKey(event)">
          <div id="search-btn" class="search-btn" onclick="app.userPrivateController.viewGenericItems.filter()"></div>
        </div>
      </div>
      <div class="header-group" id="botones-modo-visualizacion">
        <a class="btn-icon" id="btn-thumbs" onclick="app.userPrivateController.viewGenericItems.thumbs(null, '${_entity}')" title="Ver como tarjetas"></a>
        <a class="btn-list" id="btn-list" onclick="app.userPrivateController.viewGenericItems.list(null, '${_entity}')" title="Ver como lista"></a>
      </div>
      <button onclick="app.userPrivateController.${_entity}.new()">+ Nuevo</button>
    </div>
    `;
  }

  filterKey(event) {
    if (event.keyCode == 13) {
      this.filter();
    }
  }

  filter() {
    let value = document.getElementById('service-search-input')?.value || '';
    value = value.toLowerCase().trim();

    this.filterMessage();

    let itemsContainer = document.getElementById('service-table-items');
    if (itemsContainer) {
      let items = itemsContainer.querySelector('.body').children;
      if (value === '') {
        for (let i = 0; i < items.length; i++) {
          items[i].removeAttribute('style');
        }
      } else {
        let exists = false;
        for (let i = 0; i < items.length; i++) {
          if (items[i].innerText.toLowerCase().indexOf(value) > -1) {
            items[i].removeAttribute('style');
            exists = true;
          } else {
            items[i].setAttribute('style', 'display:none');
          }
        }
        if (exists === false) {
          this.filterMessage('No se encontraron publicaciones para <b class="tag-red">' + value + '</b>');
        }
      }
    } else {
      let items = document.getElementsByClassName('items mt20')[0].children;
      if (value === '') {
        for (let i = 0; i < items.length; i++) {
          items[i].removeAttribute('style');
        }
      } else {
        let exists = false;
        for (let i = 0; i < items.length; i++) {
          if (items[i].innerText.toLowerCase().indexOf(value) > -1) {
            items[i].removeAttribute('style');
            exists = true;
          } else {
            items[i].setAttribute('style', 'display:none');
          }
        }
        if (exists === false) {
          this.filterMessage('No se encontraron publicaciones para <b class="tag-red">' + value + '</b>');
        }
      }
    }
  }

  filterMessage(_text) {
    if (_text) {
      document.getElementById('mensaje-buscador-texto').innerHTML = _text;
      document.getElementById('mensaje-buscador').setAttribute('style', '');
    } else {
      document.getElementById('mensaje-buscador-texto').innerHTML = '';
      document.getElementById('mensaje-buscador').setAttribute('style', 'display:none');
    }
  }

  prepareItem(_item) {
    if (!_item) {
      _item = {};
    }

    // ESTADO
    if (_item.visible === true) {
      _item.visible = '1';
    }

    if (_item.visible === false) {
      _item.visible = '0';
    }

    _item.visibleChecked = (_item.visible === '1' ? "checked" : '');
    _item.visibleText = (_item.visible === '1' ? "Publicado" : 'Oculto');
    _item.visibleClass = (_item.visible === '1' ? "tag-green" : 'tag-red');


    // IMAGENES
    if (_item.imagenes && typeof _item.imagenes == 'string' && _item.imagenes.length > 0) {
      try {
        _item.imagenes = JSON.parse(_item.imagenes);
      } catch (error) {
        _item.imagenes = [];
        // console.log(error, _item.imagenes);
      }
    }

    if (!Array.isArray(_item.imagenes)) {
      _item.imagenes = [];
    }


    // PRECIO
    if (_item.precio && _item.moneda && _item.moneda != 0) {
      _item.price = `${_item.moneda == '1' ? 'AR$' : 'U$D'} ${APICRUD.Common.FormatMoney(_item.precio, false, false)}`;
    }

    // FECHA
    _item.fecha = APICRUD.Common.ConvertDateToSpanishShort(_item.dateUpdate || _item.dateCreate, false);


    return _item;
  }


  // #region Modes

  list(_items, _entity) {
    if (_items) {
      this.items = _items;
    }

    localStorage.setItem('entity-user-mode-' + _entity, 'list');
    document.getElementById('btn-list').classList.add('active');
    document.getElementById('btn-thumbs').classList.remove('active');
    document.getElementById('service-search-input').value = '';

    let html = '';

    for (let i = 0; i < this.items.length; i++) {
      this.items[i] = this.prepareItem(this.items[i]);
      html += `
        <div class="row" onclick="app.userPrivateController.${_entity}.edit('${this.items[i]?.idcod}')">
          <img src="${this.items[i].imagenes.length > 0 ? APICRUD.Image.GetUrl(this.items[i].imagenes[0]) : ''}" alt=""
            onerror="this.src='/assets/img/service.webp'">
          <div>${this.items[i]?.titulo || 'Sin título'}</div>
          <div>${this.items[i]?.resumen || '---'}</div>
          <div>${this.items[i].price || '---'}</div>
          <div>${this.items[i].fecha || '---'}</div>
          <div>
            <span class="${this.items[i].visibleClass}">${this.items[i].visibleText}</span>
          </div>
        </div>
      `;
    }

    if (html) {
      document.getElementById('items').innerHTML = `
        <div class="service-table-items" id="service-table-items">
          <div class="header">
            <div> </div>
            <div>Título</div>
            <div>Descripción</div>
            <div>Precio</div>
            <div>Fecha</div>
            <div>Estado</div>
          </div>
          <div class="body">${html}</div>
        </div>
        <div class="service-table-items" id="mensaje-buscador" style="display:none">
          <div class="body ac"><h3 id="mensaje-buscador-texto">Todavía no ha creado publicaciones.</h3></div>
        </div>
    `;
    } else {
      document.getElementById('items').innerHTML = this.renderEmptyMessage();
    }
  }

  renderEmptyMessage() {
    return `
        <div class="service-table-items">
          <div class="body ac"><h3>Todavía no ha creado publicaciones.</h3></div>
        </div>
    `;
  }

  thumbs(_items, _entity) {
    if (_items) {
      this.items = _items;
    }

    localStorage.setItem('entity-user-mode-' + _entity, 'thumbs');
    document.getElementById('btn-list').classList.remove('active');
    document.getElementById('btn-thumbs').classList.add('active');
    document.getElementById('service-search-input').value = '';

    let html = '';
    for (let i = 0; i < this.items.length; i++) {
      this.items[i] = this.prepareItem(this.items[i]);
      html += `
      <article>
        <div class="item pb20" onclick="app.userPrivateController.${_entity}.edit('${this.items[i]?.idcod}')">
          <img src="${this.items[i].imagenes.length > 0 ? APICRUD.Image.GetUrl(this.items[i].imagenes[0]) : ''}" alt=""
            onerror="this.src='/assets/img/service.webp'">
            <h1>${this.items[i]?.titulo || 'Sin título'}</h1>
            <p>${this.items[i]?.resumen || ''}</p>
            <div style="float: left;position: absolute;top: 10px;left: 10px;">
              <span class="${this.items[i].visibleClass}">${this.items[i].visibleText}</span>
            </div>
        </div>
      </article>
      `;
    }
    if (html) {
      document.getElementById('items').innerHTML = `
        <div class="items mt20">${html}</div> 
        <div class="service-table-items" id="mensaje-buscador" style="display:none">
          <div class="body ac"><h3 id="mensaje-buscador-texto">Todavía no ha creado publicaciones.</h3></div>
        </div>
      `;
    } else {
      document.getElementById('items').innerHTML = this.renderEmptyMessage();
    }
  }
}
